// TODO: remove this when Company-specific roles are implemented
export enum PermissionSetName {
  STANDARD = "STANDARD",
  OFFICE_ADMIN = "OFFICE_ADMIN",
  PRICER = "PRICER",
}
